import { HttpEvent, HttpInterceptor, HttpHandler, HttpRequest, HttpErrorResponse } from '@angular/common/http';
import {concatMap, delay, mergeMap, Observable, of, retry, RetryConfig, retryWhen, take, throwError} from 'rxjs';
import {catchError} from 'rxjs/operators';
import {LogService} from '../logging/log.service';
import {Injectable, Injector} from '@angular/core';

const retryConfig: RetryConfig = new class implements RetryConfig {
  count =  1;
  delay = 2000;
}

@Injectable()
export class HttpErrorInterceptor implements HttpInterceptor {
  private log: LogService;
  constructor(private injector: Injector) {
  }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    if (!this.log) {
      this.log = this.injector.get(LogService);
    }
    return next.handle(request).pipe(catchError((error) => {
        let errorMsg = '';
        if (error.error instanceof ErrorEvent) {
          errorMsg = `${error.error.message}`;
        }
        if (error.status === 0) {
          // A client-side or network error occurred. Handle it accordingly.
          console.error('An error occurred:', error.error);
          errorMsg = `${error.error.message}`
        } else {
          // The backend returned an unsuccessful response code.
          // The response body may contain clues as to what went wrong.
          console.error(`Backend returned code ${error.status}, body was: `, error.error);
          errorMsg = error.error?.message || error.message || 'Unknown error occurred';
          // errorMsg = `${error.status},  Message: ${error.message}`;
        }
        const errorResponse = {
          status: error.status,
          message: errorMsg,
          originalError: error.error, // Keep original backend response
        };
        this.log.error(errorMsg);
        return throwError(() => errorResponse);
        // return throwError(() => new Error(errorResponse));
      }),
      retry(retryConfig)
    );
  }
}
